import {EventEmitter, Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DuelViewsServiceService {

  private _duelId;
  private _hasWalkOver: boolean = false;
  private _duelCanBeReplayed: boolean;
  private _watchPlayersReplace: EventEmitter<string> = new EventEmitter<string>();
  private _updateDuePlayerReplace: string = 'update_due_players_replace';
  constructor() { };

  get duelId() {
    return this._duelId;
  }

  set duelId(value) {
    this._duelId = value;
  }

  get hasWalkOver(): boolean {
    return this._hasWalkOver;
  }

  set hasWalkOver(value) {
    this._hasWalkOver = value;
  }

  get duelCanBeReplayed(): boolean {
    return this._duelCanBeReplayed;
  }

  set duelCanBeReplayed(value) {
    this._duelCanBeReplayed = value;
  }

  get watchPlayersReplaceEventEmitter(): EventEmitter<string> {
    return this._watchPlayersReplace;
  }

  get updateDuePlayerReplace(): string {
    return  this._updateDuePlayerReplace;
  }

}
